<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.plots.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create -->
        <b-modal id="createPlots" hide-footer>
          <template v-slot:modal-title>Nova parcela</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-12">
                    <LabelRequiredField label="Valor" />
                    <input type="text" v-model="value" class="form-control" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create -->
        <v-card>
          <v-card-title>
            Parcelas
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="plots"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <!-- Modal alterar plot -->
              <b-modal :id="String(item.id)" hide-footer>
                <template v-slot:modal-title>Editar parcela</template>
                <div class="d-block">
                  <div class="container">
                    <b-overlay :show="loadingPlotsUpdate" opacity="0.99">
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                          <div class="col-md-12">
                            <LabelRequiredField label="Nome" />
                            <input
                              :disabled="!permissions.plots.edit"
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <LabelRequiredField label="Valor" />
                            <input
                              :disabled="!permissions.plots.edit"
                              type="text"
                              v-model="value"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6>
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 text-right">
                            <v-btn
                              class="v-primary m-1"
                              @click="$bvModal.hide(String(item.id))"
                            >
                              <span class="fa fa-arrow-left"></span> Voltar
                            </v-btn>
                            <v-btn
                              v-if="permissions.plots.edit"
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success"
                            >
                              <span class="fa fa-check"></span>
                              {{ loadingUpdate ? "Carregando" : "Salvar" }}
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
              <!-- /Modal alterar plot-->
              <!-- <v-btn
                small
                class="v-danger m-1"
                v-confirm="{
                      html: true,
                      loader: false,
                      ok: dialog => deletePlots(dialog, item),
                      cancel: () => {},
                      message: 'Deseja realmente apagar o tipo de estoque? <hr /> Só pode apagar caso não exista vinculo do tipo de estoque com usuários!',
                      okText: 'Confirmar',
                      cancelText: 'Cancelar',
                    }"
              >
                <span class="fa fa-times-circle"></span> Apagar
              </v-btn>-->
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import api from "../services/api";
import toast from "../components/ToastNotification";
import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Plots",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      admin_id: "",
      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Nome", value: "name" },
        { text: "Valor", value: "value" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      plot: {},
      plots: [],
      id: "",
      name: "",
      value: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingPlotsUpdate: false,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalPlots(item.id);
      this.$bvModal.show(String(item.id));
    },
    retrieve() {
      this.permissions = adminData().permissions;
      this.admin_id = adminData().admin.id;

      this.getPlots();
    },
    async getPlots(page = 1) {
      try {
        this.loading = true;

        const response = await api.get("/admin/plots/paginate", {
          params: { page },
        });

        const { plots } = response.data;

        this.plots = plots;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { admin_id, name, value } = this;

        let params = {
          admin_id,
          name,
          value,
        };

        const response = await api.post("/admin/plots/create", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("createPlots");
          this.getPlots();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { admin_id, id, name, value } = this;

        let params = {
          admin_id,
          id,
          name,
          value,
        };

        const response = await api.put("/admin/plots/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(String(id));
          this.getPlots();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.value = "";
      this.$bvModal.show("createPlots");
    },
    async handleModalPlots(id) {
      try {
        this.loadingPlotsUpdate = true;

        this.id = id;

        const response = await api.get("/admin/plots/get", {
          params: { id },
        });

        const { plots } = response.data;

        this.plot = plots;
        this.id = plots.id;
        this.name = plots.name;
        this.value = plots.value;
        this.loadingPlotsUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deletePlots(dialog, plot) {
      try {
        const { id } = plot;

        const { admin_id } = this;

        let data = { admin_id, id };

        const response = await api.delete("/admin/plots/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getPlots();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>